import React, { useState, useRef } from "react";
import {
  Alert,
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  Modal,
} from "react-bootstrap";
import Webcam from "react-webcam";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUserPlus } from "@fortawesome/free-solid-svg-icons";


const AddUserModal = (props) => {
  const [show, setShow] = useState(false);
  const [fullName, setFullName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [image, setImage] = useState(undefined);
  const [formState, setFormState] = useState("initial");
  const [capturing, setCapturing] = useState(false);
  const [uploading, setUploading] = useState(false);
  const webcamRef = useRef(null);
  const saveHandler = props.onSave;

  const getValidationState = (value) => (!value ? "error" : "success");

  const processImage = (dataUrl) => {
    const base64Image = dataUrl.split(",")[1];
    setImage(base64Image);
  };

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => processImage(reader.result);
    reader.onerror = () => setFormState("error");
  };

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    processImage(imageSrc);
    setCapturing(false);
  };

  const submitForm = (e) => {
    setFormState("saving");
    e.preventDefault();
    saveHandler({ fullName, jobTitle, image })
      .then(() => setFormState("saved"))
      .catch(() => setFormState("error"));
  };

  const toggle = (reset) => {
    setShow(!show);
    if (reset) {
      setFormState("initial");
      setFullName("");
      setJobTitle("");
      setImage(undefined);
    }
  };

  return (
    <>
      <Button
        
        onClick={() => toggle(true)}
        style={{
          borderRadius: "15px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.4)",
          border: "none",
          justifyContent: "center",
          width: "550px",
          height: "80px",
          backgroundColor: "green",
          color: "#ffffff",
          fontFamily: 'Arial, sans-serif',
          fontSize: "40px",
          fontWeight: "bold",
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center'
        }}
      >
       <FontAwesomeIcon icon={faUserPlus} style={{ marginRight: '15px' }} />
        Agrega tu biometría
      </Button>

      <Modal show={show} onHide={toggle} style={{ color: "#000" }}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar un usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Al agregar una foto de una persona estás aceptando que DANAconnect haga reconocimiento biométrico de la misma.
          </p>
          <hr />
          <Alert
            bsStyle="warning"
            style={{
              display: formState === "saving" ? "block" : "none",
            }}
          >
            Espera un momento...
          </Alert>
          <Alert
            bsStyle="danger"
            style={{
              display: formState === "error" ? "block" : "none",
            }}
          >
            Ocurrió un error al agregar el usuario. Intenta de nuevo.
          </Alert>
          <Alert
            bsStyle="success"
            style={{
              display: formState === "saved" ? "block" : "none",
            }}
          >
            ¡OK! Cierra esta ventana y haz clic en Comenzar de nuevo para registrarte.
          </Alert>
          <form
            style={{
              display: formState === "initial" ? "block" : "none",
            }}
          >
            <FormGroup
              controlId="fullName"
              validationState={getValidationState(fullName)}
            >
              <ControlLabel>Nombre completo</ControlLabel>
              <FormControl
                type="text"
                value={fullName}
                placeholder="Nombre Completo"
                onChange={(e) => setFullName(e.target.value)}
              />
              <FormControl.Feedback />
            </FormGroup>
            <FormGroup
              controlId="jobTitle"
              validationState={getValidationState(jobTitle)}
            >
              <ControlLabel>Email</ControlLabel>
              <FormControl
                type="text"
                value={jobTitle}
                placeholder="tu email"
                onChange={(e) => setJobTitle(e.target.value)}
              />
              <FormControl.Feedback />
            </FormGroup>
            <FormGroup
              controlId="image"
              validationState={getValidationState(image)}
            >
              <ControlLabel>Foto</ControlLabel>
              {capturing ? (
                <>
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    style={{ width: "100%", height: "auto" }}
                  />
                  <Button onClick={captureImage}>Capturar foto</Button>
                  <Button onClick={() => setCapturing(false)}>Cancelar</Button>
                </>
              ) : uploading ? (
                <>
                  <FormControl
                    type="file"
                    onChange={(e) => handleFileUpload(e.target.files[0])}
                    id="image"
                  />
                  <Button onClick={() => setUploading(false)}>Cancelar</Button>
                </>
              ) : (
                <>
                  <Button onClick={() => setCapturing(true)}>Activar Webcam</Button>
                  <Button onClick={() => setUploading(true)}>Subir desde el computador</Button>
                </>
              )}
              <FormControl.Feedback />
            </FormGroup>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={submitForm}
            bsStyle="primary"
            type="submit"
            disabled={
              !fullName || !jobTitle || !image || formState !== "initial"
            }
          >  <FontAwesomeIcon icon={faUser} style={{ marginRight: '15px' }} />
            Agregar usuario
          </Button>
          <Button onClick={toggle}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddUserModal;
